<template>
  <el-row :gutter="20">
    <el-col :span="12">
      <todo-widget />
    </el-col>
    <el-col :span="12">
      <partners-with-billable-widget />
    </el-col>
  </el-row>
</template>

<script>
import TodoWidget from '../components/dashboard/TodoWidget';
import PartnersWithBillableWidget from '../components/dashboard/partnersWithBillable/PartnersWithBillableWidget';

export default {
  components: { TodoWidget, PartnersWithBillableWidget },
};
</script>
